import type {
  FourthlineProviderDetails,
  KycResponse,
} from '@repo/api-kit/queries/due-diligence/kyc';

export function getFourthlineProviderDetails(
  kycInfo?: KycResponse | null
): FourthlineProviderDetails | null {
  return kycInfo?.activeProcess?.providerDetails?.$case === 'fourthlineProviderDetails'
    ? kycInfo.activeProcess.providerDetails.value
    : null;
}
